<app-call-display-smart id="callbar"></app-call-display-smart>
